module.exports = __webpack_public_path__ + "img/confidence3.83bdbf18.png";